<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Sub Component Setup</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>

  <div class="ttmodal__body">

    <div class="input-container">
      <span class="input-desc-label">Sub Component Name </span>
      <input [(ngModel)]="subCompName" type="text" placeholder="Sub Component Name" >
    </div>

    <div class="ttmodal__footer">
 
      <button  mat-raised-button color="warn"  (click)="AddNewWSRESubComp()">
          <span class="button__text">Save</span>
      </button>
    
      
    </div>
</div>

<hr>
<div style="    height: 450px;overflow-y: auto;">


  <mat-list class="header-form-full-width"  >
    <div style="align-items: center;">
      <span style="font-size: 17px;font-weight: bold;">
        Sub Component</span>
    </div>
   
    <mat-list-item *ngFor="let mp of WSREMeasurmentPoints; let i = index"  >  
      <span matLine style="font-size: 15px;">{{mp.Name}}        
     </span>
     <div style="display: flex;"> 
      <mat-icon style="vertical-align: middle; cursor: pointer;" (click)="OrderUP(mp.Order,mp.Id)" 
      [class.button-hide]="isFirstComponentInList(mp, i)">arrow_upward</mat-icon>                
      <mat-icon style="vertical-align: middle; cursor: pointer;" (click)="OrderDown(mp.Order,mp.Id)"
      [class.button-hide]="isLastComponentInList(mp, i)">arrow_downward</mat-icon>
         
     </div>
    </mat-list-item> 
  </mat-list>

</div>


</div>